import React from "react";
import { Link } from "react-router-dom";

function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      <div className="mx-auto max-w-3xl px-4 py-12 space-y-6">
        <h1 className="text-3xl font-semibold tracking-tight">Privacy Policy</h1>

        <p className="text-sm text-slate-600">
          Last updated: {new Date().toLocaleDateString()}
        </p>

        <p className="text-sm text-slate-600">
          <Link to="/terms" className="text-ypgGreen hover:underline">
            Terms &amp; Conditions
          </Link>
        </p>

        <p className="text-sm text-slate-700">
          Your Property Guys (&quot;we&quot;, &quot;us&quot;, &quot;our&quot;) respects your
          privacy. This Privacy Policy explains how we collect, use, and protect
          information when you visit our website, submit a request, or
          communicate with us by phone, SMS, or email.
        </p>

        <h2 className="text-lg font-semibold mt-4">1. Information We Collect</h2>
        <p className="text-sm text-slate-700">
          We may collect the following types of information when you contact us
          or request service:
        </p>
        <ul className="list-disc pl-5 text-sm text-slate-700 space-y-1">
          <li>Name and contact details (such as phone number and email address)</li>
          <li>Property address and basic project details</li>
          <li>Communication preferences and notes related to your service request</li>
          <li>Technical data such as IP address and basic analytics information</li>
        </ul>

        <h2 className="text-lg font-semibold mt-4">2. How We Use Your Information</h2>
        <p className="text-sm text-slate-700">
          We use the information we collect to:
        </p>
        <ul className="list-disc pl-5 text-sm text-slate-700 space-y-1">
          <li>Respond to your inquiries and provide estimates</li>
          <li>Schedule and manage service appointments</li>
          <li>Send important updates related to your project or account</li>
          <li>Improve our services and internal processes</li>
        </ul>

        <h2 className="text-lg font-semibold mt-4">3. SMS &amp; Phone Communications</h2>

        <p className="text-sm text-slate-700">
          If you provide your phone number and opt in, you may receive calls or text
          messages from <strong>Your Property Guys</strong> related to appointment
          scheduling, estimate follow-ups, customer support, and project updates.
        </p>

        <ul className="list-disc pl-5 text-sm text-slate-700 space-y-1">
          <li>
            <strong>Message frequency:</strong> Message frequency varies.
          </li>
          <li>
            <strong>Message &amp; data rates:</strong> Message and data rates may apply.
          </li>
          <li>
            <strong>Opt-out:</strong> Reply <strong>STOP</strong> to unsubscribe at any time.
          </li>
          <li>
            <strong>Help:</strong> Reply <strong>HELP</strong> for assistance.
          </li>
          <li>
            <strong>Consent not required:</strong> Consent to receive text messages is not a
            condition of purchase.
          </li>
        </ul>

        <p className="text-sm text-slate-700">
          We do not send marketing text messages without your consent. Messaging is
          intended to be directly related to your inquiry or active projects.
        </p>

        <h2 className="text-lg font-semibold mt-4">4. Sharing of Information</h2>
        <p className="text-sm text-slate-700">
          We do not sell your personal information.
        </p>

        <p className="text-sm text-slate-700">
          <strong>
            Mobile information will not be shared with third parties or affiliates for
            marketing or promotional purposes.
          </strong>
        </p>

        <p className="text-sm text-slate-700">
          We may share your information with:
        </p>
        <ul className="list-disc pl-5 text-sm text-slate-700 space-y-1">
          <li>
            Service partners or subcontractors only as needed to complete work
            you have requested
          </li>
          <li>
            Service providers that help us operate our business (for example,
            scheduling tools, messaging platforms, or analytics services)
          </li>
          <li>
            Law enforcement or other authorities if required by law or to
            protect our rights
          </li>
        </ul>

        <h2 className="text-lg font-semibold mt-4">5. Data Security</h2>
        <p className="text-sm text-slate-700">
          We take reasonable measures to protect your information from
          unauthorized access, loss, misuse, or disclosure. However, no method
          of transmission or storage is completely secure, and we cannot
          guarantee absolute security.
        </p>

        <h2 className="text-lg font-semibold mt-4">6. Your Choices</h2>
        <p className="text-sm text-slate-700">You may contact us at any time to:</p>
        <ul className="list-disc pl-5 text-sm text-slate-700 space-y-1">
          <li>Update or correct your contact information</li>
          <li>Request that we limit how we use your information</li>
          <li>Opt out of SMS or email communications related to your projects</li>
        </ul>

        <h2 className="text-lg font-semibold mt-4">7. Third-Party Services</h2>
        <p className="text-sm text-slate-700">
          Our website or communications may include links to third-party
          websites or services. We are not responsible for the privacy
          practices of those third parties. We encourage you to review their
          privacy policies separately.
        </p>

        <h2 className="text-lg font-semibold mt-4">8. Children&apos;s Privacy</h2>
        <p className="text-sm text-slate-700">
          Our services are intended for adults and property owners. We do not
          knowingly collect personal information from children under 13. If you
          believe a child has provided us with personal information, please
          contact us so we can remove it.
        </p>

        <h2 className="text-lg font-semibold mt-4">9. Changes to This Policy</h2>
        <p className="text-sm text-slate-700">
          We may update this Privacy Policy from time to time. When we do, we
          will revise the &quot;Last updated&quot; date at the top of this page.
          Continued use of our website or services after changes are posted
          means you accept the updated policy.
        </p>

        <h2 className="text-lg font-semibold mt-4">10. Contact Us</h2>
        <p className="text-sm text-slate-700">
          If you have any questions about this Privacy Policy or how we handle
          your information, please contact us at:
        </p>
        <p className="text-sm text-slate-700">
          <strong>Your Property Guys</strong>
          <br />
          Memphis, Tennessee
          <br />
          Phone: (901) 441-5099
          <br />
          Email: info@yourpropertyguys.com
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
